---
title: Resource library
slug: resource-library
type: resource
status: published
featured: true
summary: Working notes that sit with the books — innovation portfolios, product-line practice, platform strategy, and computational social science.
sitePublishedAt: "2026-09-18"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - innovation-systems
  - platform-architecture
sourceUrl: https://jayvanzyl.me/resources/
originalAuthor: Jay van Zyl
sourceRelationship: first-party resource library
rightsStatus: first-party
seoDescription: Working notes on innovation portfolios, product lines, platforms, and computational social science.
canonicalPath: /resources/resource-library
---

These notes sit with the books. They cover innovation portfolios, product-line practice, platform strategy, and computational social science.
